var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBreakoutRoomSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.625 25.5814H22.2064C24.4155 25.5814 26.2064 23.7905 26.2064 21.5814V4C26.2064 1.79086 24.4155 0 22.2064 0H4.625C2.41586 0 0.625 1.79086 0.625 4V21.5814C0.625 23.7905 2.41586 25.5814 4.625 25.5814ZM9.836 20.3703H16.9953C19.2045 20.3703 20.9953 18.5795 20.9953 16.3703V9.21101C20.9953 7.00187 19.2045 5.211 16.9953 5.211H9.83601C7.62687 5.211 5.836 7.00186 5.836 9.211V16.3703C5.836 18.5795 7.62686 20.3703 9.836 20.3703Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0435 25.5814H51.6249C53.834 25.5814 55.6249 23.7905 55.6249 21.5814V4C55.6249 1.79086 53.834 0 51.6249 0H34.0435C31.8343 0 30.0435 1.79086 30.0435 4V21.5814C30.0435 23.7905 31.8343 25.5814 34.0435 25.5814ZM39.2546 20.3703H46.4139C48.6231 20.3703 50.414 18.5795 50.414 16.3703V9.21101C50.414 7.00187 48.6231 5.211 46.414 5.211H39.2546C37.0455 5.211 35.2546 7.00186 35.2546 9.211V16.3703C35.2546 18.5795 37.0455 20.3703 39.2546 20.3703Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6948 55.0001H36.2762C38.4854 55.0001 40.2762 53.2092 40.2762 51.0001V33.4187C40.2762 31.2096 38.4854 29.4187 36.2762 29.4187H18.6948C16.4857 29.4187 14.6948 31.2096 14.6948 33.4187V51.0001C14.6948 53.2092 16.4857 55.0001 18.6948 55.0001ZM23.9058 49.7892H31.0651C33.2743 49.7892 35.0651 47.9983 35.0651 45.7892V38.6299C35.0651 36.4207 33.2743 34.6299 31.0651 34.6299H23.9058C21.6966 34.6299 19.9058 36.4207 19.9058 38.6299V45.7892C19.9058 47.9983 21.6966 49.7892 23.9058 49.7892Z",
    fill: "#D9D9D9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5734,
    cy: 14.5224,
    r: 2.9845,
    transform: "rotate(-90.5031 15.5734 14.5224)",
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.4186,
    cy: 14.9486,
    r: 2.9845,
    transform: "rotate(-90.5031 45.4186 14.9486)",
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.0695,
    cy: 44.3672,
    r: 2.9845,
    transform: "rotate(-90.5031 30.0695 44.3672)",
    fill: "#D9D9D9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4572,
    cy: 9.83243,
    r: 2.9845,
    transform: "rotate(-90.5031 10.4572 9.83243)",
    fill: "#D9D9D9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.3024,
    cy: 10.2587,
    r: 2.9845,
    transform: "rotate(-90.5031 40.3024 10.2587)",
    fill: "#D9D9D9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9533,
    cy: 39.6773,
    r: 2.9845,
    transform: "rotate(-90.5031 24.9533 39.6773)",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakoutRoomSpace);
export default __webpack_public_path__ + "static/media/breakout-room-space.f8b4cce3d67a83b75a35daa2f183699e.svg";
export { ForwardRef as ReactComponent };